var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cobranza-detail',{attrs:{"cobranza-id":_vm.item.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }